import { Outlet, createRootRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, type ReactNode } from 'react';

import { KycRequiredRedirect } from '../components/kyc-required-redirect.tsx';
import { SessionExpiredOverlay } from '../components/session-expired-overlay.tsx';
import { SessionTerminatedRedirect } from '../components/session-terminated-redirect.tsx';
import { Toast } from '../components/toast.tsx';
import { usePlatform } from '../platform/index.ts';

const RootLayout = (): ReactNode => {
  const platform = usePlatform();
  const navigate = useNavigate();
  // Surface a "Settings" entry in Telegram's ⋯ menu (alongside Telegram's own
  // Share / Reload / Add-to-Home) that opens the account screen, matching the
  // pre-rewrite app. Wired once at the root; the returned cleanup detaches it.
  useEffect(
    () => platform.onSettings(() => void navigate({ to: '/account' })),
    [navigate],
  );
  return (
    <>
      <Outlet />
      <Toast />
      <SessionExpiredOverlay />
      <SessionTerminatedRedirect />
      <KycRequiredRedirect />
    </>
  );
};

// The miniapp has no persistent app-chrome: each screen owns its own
// topbar (back + title + action). The root hosts the route outlet,
// the global toast region, and the session-expired overlay that fires
// when the api client detects a 401 + AUTH_STALE response.
export const rootRoute = createRootRoute({
  component: RootLayout,
});
